import { render, staticRenderFns } from "./ReferralNew.vue?vue&type=template&id=475fe95c&"
import script from "./ReferralNew.vue?vue&type=script&lang=ts&"
export * from "./ReferralNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports